var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsUndone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25.5C19.9036 25.5 25.5 19.9036 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5ZM16.3145 11.3146C16.6807 10.9484 16.6807 10.3549 16.3145 9.98874C15.9484 9.62262 15.3548 9.62262 14.9887 9.98874L13 11.9775L11.0112 9.98874C10.6451 9.62262 10.0515 9.62262 9.68541 9.98874C9.3193 10.3549 9.3193 10.9484 9.68541 11.3146L11.6742 13.3033L9.68541 15.292C9.3193 15.6582 9.3193 16.2517 9.68541 16.6179C10.0515 16.984 10.6451 16.984 11.0112 16.6179L13 14.6291L14.9887 16.6179C15.3548 16.984 15.9484 16.984 16.3145 16.6179C16.6807 16.2517 16.6807 15.6582 16.3145 15.292L14.3258 13.3033L16.3145 11.3146Z",
    fill: "#FF3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsUndone);
export default __webpack_public_path__ + "static/media/mark-as-undone.4095a4585e2505894de9300666cca0d3.svg";
export { ForwardRef as ReactComponent };